import React, {Component} from 'react';
import {Form, Layout, notification} from "antd";
import {ActivityIndicator} from "antd-mobile";
import {withTranslation} from "react-i18next";
import UserService from "../../../apiServices/UserService";
import "../../../App.css"
import * as _ from "lodash";

const { Header, Content } = Layout;

class VerifyEmail extends Component {

    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        const verifyCode = urlParams.get('code');

        this.state = {
            loading: false,
            verifyCode: verifyCode
        }
    }

    componentDidMount() {
        UserService.verifyEmail(this.state.verifyCode).then(response => {
            notification.success({
                message: 'Xác thực tài khoản thành công',
                description:'',
            });
            this.setState({loading: true});
            this.props.history.push('/');
        }).catch(error => {
            notification.error({
                message: error,
                description: _.get(error, 'response.message', 'Error'),
            });
        });
    }

    render() {
        const {loading} = this.props;
        let indicator = (<ActivityIndicator toast text="Loading..." size="large" />);
        if (loading){
            indicator = (<h1 className="header-logo">Xác thực thành công</h1>);
        }
        return (
            <div className={'main-login'}>
                <Header className={"header"}>
                </Header>
                <Content>
                    {indicator}
                </Content>
            </div>
        )
    }
}

VerifyEmail = Form.create()(VerifyEmail);

export default (withTranslation())(VerifyEmail);